export const FAKE_DATA = {
  folders: [
    {
      name: 'folder 1 renamed',
      videos: [1, 3],
      created_at: 1590576127908,
      last_modified: 1590576127908,
      id: 1,
    },
    {
      name: 'folder 2 sasas',
      videos: [2],
      created_at: 1590575701883,
      last_modified: 1590575701883,
      id: 2,
    },
    {
      name: 'folder 3',
      videos: [3],
      created_at: 1590575467989,
      last_modified: 1590575467989,
      id: 3,
    },
  ],
  videos: [
    {
      id: 1,
      videoId: 1,
      name: 'Crew Demo-2',
      description:
        'After standing down from launch on Wednesday, May 27, SpaceX is now targeting Saturday, May 30 for Falcon 9’s launch of Crew Dragon’s second demonstration (Demo-2) mission from Launch Complex 39A (LC-39A) at NASA’s Kennedy Space Center in Florida. This test flight with NASA astronauts Bob Behnken and Doug Hurley on board the Dragon spacecraft will return human spaceflight to the United States. The instantaneous launch window opens at 3:22 p.m. EDT, or 19:22 UTC, with a backup instantaneous launch opportunity available on Sunday, May 31 at 3:00 p.m. EDT, or 19:00 UTC. Tune in here to watch the launch webcast. Coverage will begin about 4 hours before liftoff. Demo-2 is the final major test for SpaceX’s human spaceflight system to be certified by NASA for operational crew missions to and from the International Space Station. SpaceX is returning human spaceflight to the United States with one of the safest, most advanced systems ever built, and NASA’s Commercial Crew Program is a turning point for America’s future in space exploration that lays the groundwork for future missions to the Moon, Mars, and beyond.',
      impressions: 232000,
      image: 'http://img.youtube.com/vi/rjb9FdVdX5I/maxresdefault.jpg',
      date: '10.03.2020',
      views: 8935512,
      likes: 40497,
      dislikes: 296,
      comments: 106,
      engagement_ratio: 30,
      watch_time: '9:12',
      watch_time_ratio: 73,
      click_through_rate: 1.8099,
      ad_revenue: 9439,
      production_cost: 801,
      roi: 11.0531,
      link: 'https://www.youtube.com/embed/rjb9FdVdX5I',
    },
    {
      id: 2,
      videoId: 2,
      name: 'Starlink Mission',
      description:
        'SpaceX is targeting Saturday, June 13 at 5:21 a.m. EDT, 9:21 UTC, for launch of its ninth Starlink mission, which will include 58 Starlink satellites and three of Planet’s SkySats. Falcon 9 will lift off from Space Launch Complex 40 (SLC-40) at Cape Canaveral Air Force Station, and a backup opportunity is available on Sunday, June 14 at 4:59 a.m. EDT, 8:59 UTC. This mission marks SpaceX’s first SmallSat Rideshare Program launch. Falcon 9’s first stage previously supported Dragon’s 19th and 20th resupply missions to the International Space Station. Following stage separation, SpaceX will land Falcon 9’s first stage on the “Of Course I Still Love You” droneship, which will be stationed in the Atlantic Ocean. Half of Falcon 9’s fairing previously flew on the JCSAT-18/Kacific1 mission, and the other half previously flew on SpaceX’s third Starlink mission.',
      impressions: 232000,
      image: 'http://img.youtube.com/vi/8riKQXChPGg/maxresdefault.jpg',
      date: '11.05.2020',
      views: 355270,
      likes: 23323,
      dislikes: 23,
      comments: 44,
      engagement_ratio: 71,
      watch_time: '29:12',
      watch_time_ratio: 78,
      click_through_rate: 1.1,
      ad_revenue: 3000,
      production_cost: 330,
      roi: 5.5,
      link: 'https://www.youtube.com/watch?v=8riKQXChPGg',
    },
    {
      id: 3,
      videoId: 3,
      name: 'Crew Demo 2 (Approach and Docking)',
      description:
        'Part 1: Launch - https://youtu.be/xY96v0OIcK4; Part 2: Coast - https://youtu.be/z9uAN6YNkP0; Part 3: Approach/Docking; On Saturday, May 30th,  Falcon 9 successfully launched Crew Dragon’s second demonstration (Demo-2) mission from Launch Complex 39A (LC-39A) at NASA’s Kennedy Space Center in Florida. This test flight with NASA astronauts Bob Behnken and Doug Hurley on board the Dragon spacecraft initiated the return of human spaceflight to the United States. Demo-2 is the final major test for SpaceX’s human spaceflight system to be certified by NASA for operational crew missions to and from the International Space Station. With this launch, SpaceX helped initiate the return of human spaceflight to the United States with one of the safest, most advanced systems ever built.  NASA’s Commercial Crew Program is a turning point for America’s future in space exploration that lays the groundwork for future missions to the Moon, Mars, and beyond.',
      impressions: 232000,
      image: 'http://img.youtube.com/vi/AIyonw6LEOs/maxresdefault.jpg',
      date: '08.02.2020',
      views: 8689063,
      likes: 53008,
      dislikes: 521,
      comments: 246,
      engagement_ratio: 16,
      watch_time: '9:12',
      watch_time_ratio: 98,
      click_through_rate: 1.8256,
      ad_revenue: 2118,
      production_cost: 268,
      roi: 3.4263,
      link: 'https://www.youtube.com/watch?v=AIyonw6LEOs',
    },
    {
      id: 4,
      videoId: 4,
      name: 'JCSAT-18/Kacific1 Mission',
      impressions: 232000,
      description:
        'SpaceX is targeting Monday, December 16 for launch of JCSAT-18/Kacific1 from Space Launch Complex 40 (SLC-40) at Cape Canaveral Air Force Station, Florida. The launch window opens at 7:10 p.m EST, or 00:10 UTC on December 17, and closes at 8:38 p.m. EST, 01:38 UTC on December 17. A backup launch window is available on Tuesday, December 17 that opens at 7:10 p.m EST, or 00:10 UTC on December 18, and closes at 8:38 p.m. EST, 01:38 UTC on December 18. The satellite will be deployed at approximately 33 minutes after liftoff. Falcon 9’s first stage for the JCSAT-18/Kacific1 mission previously supported the CRS-17 mission in May 2019 and the CRS-18 mission in July 2019. Following stage separation, SpaceX will land Falcon 9’s first stage on the “Of Course I Still Love You” droneship, which will be stationed in the Atlantic Ocean. Approximately 45 minutes after liftoff, SpaceX’s two fairing recovery vessels, “Ms. Tree” and “Ms. Chief,” will attempt to recover the two fairing halves.',
      image: 'http://img.youtube.com/vi/sbXgZg9JmkI/maxresdefault.jpg',
      date: '13.01.2020',
      views: 1870994,
      likes: 96659,
      dislikes: 551,
      comments: 398,
      engagement_ratio: 95,
      watch_time: '9:12',
      watch_time_ratio: 69,
      click_through_rate: 1.5944,
      ad_revenue: 8596,
      production_cost: 851,
      roi: 13.0535,
      link: 'hhttps://www.youtube.com/watch?v=sbXgZg9JmkI',
    },
    {
      id: 5,
      videoId: 5,
      name: 'AMOS-17 MISSION',
      description:
        '*The YouTube event start time reflects the targeted liftoff time for this mission. The live webcast will begin about 15 minutes before liftoff. SpaceX is targeting Tuesday, August 6 for launch of AMOS-17 from Space Launch Complex 40 (SLC-40) at Cape Canaveral Air Force Station, Florida. The launch window opens at 6:53 p.m. EDT, or 22:53 UTC, and closes at 8:21 p.m. EDT, or 00:21 UTC on August 7. The satellite will be deployed approximately 31 minutes after liftoff. Falcon 9’s first stage for the AMOS-17 mission previously supported the Telstar-19 VANTAGE mission in July 2018 and the Es’hail-2 mission in November 2018.',
      impressions: 232000,
      image: 'http://img.youtube.com/vi/fZh82-WcCuo/maxresdefault.jpg',
      date: '22.04.2020',
      views: 7667778,
      likes: 89954,
      dislikes: 252,
      comments: 372,
      engagement_ratio: 62,
      watch_time: '9:12',
      watch_time_ratio: 29,
      click_through_rate: 1.4782,
      ad_revenue: 9097,
      production_cost: 496,
      roi: 19.0892,
      link: 'https://www.youtube.com/watch?v=fZh82-WcCuo',
    },
  ],
};
